/**
* @file 框架
**/
<template>
  <div id="frame" class="frame-wrapper">
    <audio ref="audio_newOrder" :src="require('../../assets/mp3/new_msg.mp3')"></audio>
    <audio ref="audio_sfxNewOrder" :src="require('../../assets/mp3/sfx_new_msg.mp3')"></audio>
    <frame-header></frame-header>

    <router-view
      v-if="['orderForm', 'orderFormByChannel2', 'travelReservationSure', 'fitOrder'].includes($route.name)"></router-view>

    <div class="frame-content" v-else>
      <frame-menu></frame-menu>
      <div class="frame-inner-box" :class="{ 'fullscreen-box': isFullscreenPage }" v-if="pageType != 'content'">
        <!-- 页面头部：标题和面包屑（全屏布局页面不显示） -->
        <div class="page-header-bar" v-if="$route.name !== 'workbench' && !isFullscreenPage">
          <div class="page-header-left">
            <div class="page-title">
              <i :class="currentPageIcon"></i>
              <span>{{ currentPageTitle }}</span>
            </div>
            <el-breadcrumb separator="/" class="page-breadcrumb" v-if="autoBreadcrumb.length > 0">
              <el-breadcrumb-item 
                v-for="(item, index) in autoBreadcrumb" 
                :key="index"
                :to="index < autoBreadcrumb.length - 1 && item.path ? { path: item.path } : null">
                {{ item.name }}
              </el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="page-header-right">
            <el-button size="small" icon="el-icon-back" @click="goBack" v-if="breadcrumb && breadcrumb.length > 0">返回</el-button>
          </div>
        </div>
        <div class="frame-inner" :class="{ 'has-header': $route.name !== 'workbench', 'fullscreen-layout': isFullscreenPage }">
          <router-view></router-view>
        </div>
      </div>
      <div class="frame-inner-box-fixed" v-else>
        <div class="flex breadcrumb-box" v-if="breadcrumb && breadcrumb.length > 0">
          <el-button size="small" @click="goBack">返回</el-button>
          <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-left: 10px;">
            <el-breadcrumb-item :to="item.path" v-for="(item, index) in breadcrumb" :key="index">{{ item.name }}
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="frame-inner">
          <router-view></router-view>
        </div>
      </div>
    </div>

    <el-dialog title="账户余额不足" width="30%" :visible.sync="billVisible" :before-close="() => (billVisible = false)"
      :append-to-body="true" class="rich">
      <div class="content">
        系统将于
        <span> {{ richTime }} </span>
        自动扣费，请确保您的账户余额充足，因账户余额不足导致扣费失败，系统将自动停机/暂停使用。
      </div>
      <div class="content">应付费用：￥{{ serviceFee }}</div>
      <div class="content">
        账户余额：￥{{ balance }} <span> (账户余额不足) </span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="details" size="mini" type="primary">查看详情</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import FrameHeader from "./header";
import FrameMenu from "./menu";
import { mapGetters } from "vuex";

export default {
  name: "frame",
  components: { FrameHeader, FrameMenu },
  computed: {
    ...mapGetters({
      messageGetter: "messageGetter",
    }),
    // 当前页面标题
    currentPageTitle() {
      // 优先使用路由meta中的breadcrumb最后一项
      if (this.$route.meta && this.$route.meta.breadcrumb && this.$route.meta.breadcrumb.length > 0) {
        return this.$route.meta.breadcrumb[this.$route.meta.breadcrumb.length - 1].name;
      }
      // 从菜单中获取
      const menuItem = this.findMenuByPath(this.$route.path);
      if (menuItem) {
        return menuItem.menuName;
      }
      // 从路由name获取
      if (this.$route.name) {
        return this.getPageTitleByRouteName(this.$route.name);
      }
      return '';
    },
    // 当前页面图标
    currentPageIcon() {
      const path = this.$route.path;
      // 图标映射
      const iconMap = {
        'order': 'el-icon-s-order',
        'financial': 'el-icon-money',
        'resource': 'el-icon-s-data',
        'scheduling': 'el-icon-date',
        'operation': 'el-icon-s-operation',
        'business': 'el-icon-s-shop',
        'dataAnalysis': 'el-icon-s-marketing',
        'dispatch': 'el-icon-s-promotion',
        'driver': 'el-icon-s-custom',
        'vehicle': 'el-icon-truck',
        'cost': 'el-icon-wallet'
      };
      for (const key in iconMap) {
        if (path && path.toLowerCase().includes(key.toLowerCase())) {
          return iconMap[key];
        }
      }
      return 'el-icon-document';
    },
    // 是否是全屏布局页面（数据分析等BI风格页面）
    isFullscreenPage() {
      const fullscreenRoutes = [
        'dataOverview', 'vehicleAnalysis', 'orderAnalysis', 
        'driverAnalysis', 'revenueAnalysis', 'analysisStatistics'
      ];
      return fullscreenRoutes.includes(this.$route.name);
    },
    // 自动生成的面包屑
    autoBreadcrumb() {
      // 优先使用路由meta中配置的breadcrumb
      if (this.$route.meta && this.$route.meta.breadcrumb && this.$route.meta.breadcrumb.length > 0) {
        return this.$route.meta.breadcrumb;
      }
      // 从菜单结构自动生成
      const result = [];
      const menuItem = this.findMenuByPath(this.$route.path);
      if (menuItem) {
        // 添加父级菜单
        if (menuItem.parent) {
          result.push({
            name: menuItem.parent.menuName,
            path: menuItem.parent.path || ''
          });
        }
        // 添加当前页面
        result.push({
          name: menuItem.menuName,
          path: this.$route.path
        });
      } else {
        // 菜单未加载时，使用路由name生成面包屑
        const title = this.getPageTitleByRouteName(this.$route.name);
        if (title) {
          // 根据路由路径推断父级菜单
          const parentInfo = this.getParentInfoByPath(this.$route.path);
          if (parentInfo) {
            result.push(parentInfo);
          }
          result.push({
            name: title,
            path: this.$route.path
          });
        }
      }
      return result;
    },
    richTime() {
      let date = new Date();
      return date.getDate() < 5
        ? `${date.getFullYear()}-${date.getMonth() + 1}-05 00:00:00`
        : `${date.getMonth() + 2 > 12
          ? date.getFullYear() + 1
          : date.getFullYear()
        }-${date.getMonth() + 2 > 12 ? "1" : date.getMonth() + 2
        }-05 00:00:00`;
    },
  },
  data() {
    return {
      // 面包屑组件
      breadcrumb: [],
      billVisible: false, // 欠费通知
      balance: null,
      serviceFee: null,
      pageType: '',
      // 菜单数据缓存
      menuCache: []
    };
  },
  watch: {
    messageGetter(val) {
      if (val) {
        switch (val.msg) {
          case "HitchRideOrderCreated":  // 顺风车新订单
            if (this.mixinUserInfo.platformType === 3) {
              this.$message.success("有乘客发布了新的行程");
              this.$refs.audio_sfxNewOrder.currentTime = 0;
              this.$refs.audio_sfxNewOrder.play();
            }
            break;
          case "Pay": // 新订单
            if (
              this.mixinUserInfo.organizationType === 1 ||
              (this.mixinUserInfo.organizationType === 2 &&
                val.data.organizationId === this.mixinUserInfo.organizationId)
            ) {
              this.$message.success("有新的待指派订单，请及时处理");
              this.$refs.audio_newOrder.currentTime = 0;
              this.$refs.audio_newOrder.play();
            }
            break;
          case "BILL": // 欠费提示
            [this.balance, this.serviceFee] = [
              val.data.balance,
              val.data.serviceFee,
            ];
            this.billVisible = true;
            break;
          case "SHUTDOWN": // 停机退出
            this.$message.info("系统余额不足，已暂停使用");
            this.$store.dispatch("acLogout");
            break;
        }
      }
    },
    $route: {
      deep: true,
      immediate: true,
      handler(val) {
        this.pageType = val.meta.type;
        // 面包屑处理
        if (val.meta.breadcrumb && val.meta.breadcrumb.length > 0) {
          if (val.name === 'organizationForm') {
            this.breadcrumb = val.meta.breadcrumb;
            this.breadcrumb[1].name = val.query.type == 1 ? '总机构信息' : '分机构信息'
          } else {
            this.breadcrumb = val.meta.breadcrumb;
          }
        } else {
          this.breadcrumb = [];
        }
      },
    },
  },
  async created() {
    // 预先加载菜单数据
    this.loadMenuCache();
    // 监听菜单更新，刷新面包屑/页面标题所用的菜单缓存
    this.$bus.$on('menu-updated', this.loadMenuCache)
    
    if (this.mixinUserInfo.platformType == 3) {
      this.getCityList();
    }
    // 在框架页连接mqtt
    let url = "/api/v1/common/mqtt_config";
    let data = await this.$axios.get(url);
    if (data && data.code === 1) {
      this.$mqtt.mqttConnect(data.data);
      this.$mqtt.newTopic({
        tpc: "/bus/admin/" + this.mixinUserInfo.appKey,
        opt: {
          qos: 1,
        },
      });
      if (this.mixinUserInfo.organizationType === 1) {
        this.$mqtt.newTopic({
          tpc: "/bus/organization/" + this.mixinUserInfo.appKey,
          opt: {
            qos: 1,
          },
        });
      }
    }
  },
  mounted() {
    if(this.mixinUserInfo.platformType == 3) {
      this.$watermark.init()
    }
  },
  methods: {
    // 根据路径推断父级菜单信息
    getParentInfoByPath(path) {
      const parentMap = {
        // 订单管理（组件级Tab，统一使用/order路径）
        '/order': { name: '订单管理', path: '' },
        '/hitchRideOrderDispatch': { name: '订单管理', path: '' },
        '/hitchRideOrderHistory': { name: '订单管理', path: '' },
        '/hitchRideOrderVirtual': { name: '订单管理', path: '' },
        '/hitchRideDriverFeedback': { name: '订单管理', path: '' },
        // 工单管理
        '/orderDriverCustomize': { name: '工单管理', path: '' },
        '/orderDriverLine': { name: '工单管理', path: '' },
        '/orderHitchhikingWork': { name: '工单管理', path: '' },
        '/czOrderDriver': { name: '工单管理', path: '' },
        '/hitchRideWork': { name: '工单管理', path: '' },
        // 调度管理
        '/dispatchCustomize': { name: '调度管理', path: '' },
        '/dispatchChartered': { name: '调度管理', path: '' },
        '/dispatchLine': { name: '调度管理', path: '' },
        '/schedulingDispatch': { name: '调度管理', path: '' },
        '/occupySeat': { name: '调度管理', path: '' },
        // 资源管理
        '/driver': { name: '资源管理', path: '' },
        '/vehicle': { name: '资源管理', path: '' },
        '/driverChannel': { name: '资源管理', path: '' },
        '/securityInspector': { name: '资源管理', path: '' },
        '/passenger': { name: '资源管理', path: '' },
        '/systemBackups': { name: '资源管理', path: '' },
        // 排班管理
        '/customize': { name: '排班管理', path: '' },
        '/line': { name: '排班管理', path: '' },
        // 财务管理
        '/financialCustomize': { name: '财务管理', path: '' },
        '/financialChartered': { name: '财务管理', path: '' },
        '/financialCustomizeChartered': { name: '财务管理', path: '' },
        '/financialLine': { name: '财务管理', path: '' },
        '/financeFlowingHitchRide': { name: '财务管理', path: '' },
        '/czOrderFlowing': { name: '财务管理', path: '' },
        '/financialLvYou': { name: '财务管理', path: '' },
        '/costCenter': { name: '财务管理', path: '' },
        '/organizationFlowing': { name: '财务管理', path: '' },
        '/invoice': { name: '财务管理', path: '' },
        '/ticketStatistics': { name: '财务管理', path: '' },
        '/stationSettle': { name: '财务管理', path: '' },
        '/inspectStatistics': { name: '财务管理', path: '' },
        '/stationReferrerSettle': { name: '财务管理', path: '' },
        '/settlement': { name: '财务管理', path: '' },
        '/airportAccountSettle': { name: '财务管理', path: '' },
        '/organizationHitchRideBill': { name: '财务管理', path: '' },
        // 票据管理
        '/ticketManagePush': { name: '票据管理', path: '' },
        '/ticketManageGet': { name: '票据管理', path: '' },
        // 运营管理
        '/driverAudit': { name: '运营管理', path: '' },
        '/vehicleAudit': { name: '运营管理', path: '' },
        '/feedback': { name: '运营管理', path: '' },
        '/station': { name: '运营管理', path: '' },
        // 业务设置
        '/platform': { name: '业务设置', path: '' },
        '/driverPort': { name: '业务设置', path: '' },
        '/passengerPort': { name: '业务设置', path: '' },
        '/ticketing': { name: '业务设置', path: '' },
        '/seat': { name: '业务设置', path: '' },
        '/protocol': { name: '业务设置', path: '' },
        '/chartered': { name: '业务设置', path: '' },
        '/regionalRestrictions': { name: '业务设置', path: '' },
        '/sensitivePersonnel': { name: '业务设置', path: '' },
        '/notification': { name: '业务设置', path: '' },
        '/training': { name: '业务设置', path: '' },
        '/securityTemplate': { name: '业务设置', path: '' },
        '/orderStationSettle': { name: '业务设置', path: '' },
        '/stationReferrerConfig': { name: '业务设置', path: '' },
        // 规则管理
        '/hitchRidePricingRule': { name: '规则管理', path: '' },
        '/hitchRideCancelRule': { name: '规则管理', path: '' },
        '/hitchRideSettleRule': { name: '规则管理', path: '' },
        '/hitchRideWithdrawalRule': { name: '规则管理', path: '' },
        '/hitchRideDriverAuditRule': { name: '规则管理', path: '' },
        '/airportCommissionRule': { name: '规则管理', path: '' },
        '/driverWithdrawalRule': { name: '规则管理', path: '' },
        '/dispatchWithdrawalRule': { name: '规则管理', path: '' },
        '/hitchRideAutoAccept': { name: '规则管理', path: '' },
        // 业务管理
        '/commission': { name: '业务管理', path: '' },
        '/riskConfig': { name: '业务管理', path: '' },
        // 活动管理
        '/invitation': { name: '活动管理', path: '' },
        '/chargeOrder': { name: '活动管理', path: '' },
        // 营销管理
        '/advertising': { name: '营销管理', path: '' },
        '/topic': { name: '营销管理', path: '' },
        '/carousel': { name: '营销管理', path: '' },
        '/sticker': { name: '营销管理', path: '' },
        '/coupon': { name: '营销管理', path: '' },
        '/couponReceiving': { name: '营销管理', path: '' },
        '/recommendedLine': { name: '营销管理', path: '' },
        '/marketingActivity': { name: '营销管理', path: '' },
        // 数据分析
        '/dataOverview': { name: '数据分析', path: '' },
        '/vehicleAnalysis': { name: '数据分析', path: '' },
        '/driverAnalysis': { name: '数据分析', path: '' },
        '/orderAnalysis': { name: '数据分析', path: '' },
        '/revenueAnalysis': { name: '数据分析', path: '' },
        // 统计分析
        '/hitchRideOrderStatistics': { name: '统计分析', path: '' },
        '/operationData': { name: '统计分析', path: '' },
        '/vehicleFlowing': { name: '统计分析', path: '' },
        '/driverFlowing': { name: '统计分析', path: '' },
        // AI管理
        '/aiCard': { name: 'AI管理', path: '' },
        '/aiConfig': { name: 'AI管理', path: '' },
        // 短信管理
        '/smsTemplate': { name: '短信管理', path: '' },
        '/smsRecord': { name: '短信管理', path: '' },
        '/smsConfig': { name: '短信管理', path: '' },
        '/smsStatistics': { name: '短信管理', path: '' },
        // 系统设置
        '/member': { name: '系统设置', path: '' },
        '/role': { name: '系统设置', path: '' },
        '/dataBackup': { name: '系统设置', path: '' },
        '/organization': { name: '系统设置', path: '' },
        '/log': { name: '系统设置', path: '' },
        '/inspector': { name: '系统设置', path: '' },
        '/hitchRideAdverseRecord': { name: '系统设置', path: '' },
        // 旅游包车
        '/charteredOrder': { name: '旅游包车', path: '/charteredModule' },
        '/charteredWork': { name: '旅游包车', path: '/charteredModule' },
        '/charteredFinancial': { name: '旅游包车', path: '/charteredModule' },
        '/charteredSetting': { name: '旅游包车', path: '/charteredModule' },
        '/charteredStatistics': { name: '旅游包车', path: '/charteredModule' },
        // 场站管理
        '/czLine': { name: '场站管理', path: '' },
        '/airportStart': { name: '场站管理', path: '' },
        '/czAccount': { name: '场站管理', path: '' },
        // 文旅管理
        '/travelLine': { name: '文旅管理', path: '' },
        '/travelGoods': { name: '文旅管理', path: '' },
        '/travelReservation': { name: '文旅管理', path: '' },
        '/travelReservationManager': { name: '文旅管理', path: '' },
        '/travelOrder': { name: '文旅管理', path: '' },
        '/travelItinerary': { name: '文旅管理', path: '' },
        // 渠道管理
        '/channelAudit': { name: '渠道管理', path: '' },
        '/channelList': { name: '渠道管理', path: '' },
        '/channelOrder': { name: '渠道管理', path: '' },
        '/channelFinancial': { name: '渠道管理', path: '' },
        '/channelCommission': { name: '渠道管理', path: '' },
        '/channelWithdrawal': { name: '渠道管理', path: '' }
      };
      return parentMap[path] || null;
    },
    // 根据路由name获取页面标题
    getPageTitleByRouteName(routeName) {
      const titleMap = {
        // 订单管理
        'order': '订单管理',
        'orderCustomize': '专线订单',
        'orderChartered': '旅游包车',
        'orderCustomizeChartered': '专线包车',
        'orderLine': '班线订单',
        'orderHitchhiking': '顺风车',
        'airportOrder': '场站订单',
        'hitchRideOrderDispatch': '顺风车调度',
        'hitchRideOrderHistory': '历史订单',
        'hitchRideOrderVirtual': '虚拟订单',
        'hitchRideDriverFeedback': '用户反馈',
        // 工单管理
        'orderDriverCustomize': '专线工单',
        'orderDriverLine': '班线工单',
        'orderHitchhikingWork': '顺风车工单',
        'czOrderDriver': '场站工单',
        'hitchRideWork': '客诉工单',
        // 调度管理
        'dispatchCustomize': '专线调度',
        'dispatchChartered': '包车调度',
        'dispatchLine': '班线调度',
        'schedulingDispatch': '班次调度',
        'occupySeat': '占座管理',
        // 资源管理
        'driver': '司机资源',
        'vehicle': '车辆资源',
        'driverChannel': '渠道资源',
        'securityInspector': '安全检查',
        'passenger': '乘客管理',
        'systemBackups': '数据备份',
        // 排班管理
        'customize': '定制客运',
        'line': '班线客运',
        // 财务管理
        'financialCustomize': '专线订单',
        'financialChartered': '旅游包车',
        'financialCustomizeChartered': '专线包车',
        'financialLine': '班线订单',
        'financeFlowingHitchRide': '顺风车流水',
        'czOrderFlowing': '场站流水',
        'financialLvYou': '文旅流水',
        'costCenter': '费用中心',
        'organizationFlowing': '公司钱包',
        'invoice': '发票管理',
        'ticketStatistics': '售票统计',
        'stationSettle': '结算管理',
        'inspectStatistics': '安检统计',
        'stationReferrerSettle': '推荐结算',
        'settlement': '结算审核',
        'airportAccountSettle': '场站结算',
        'organizationHitchRideBill': '机构账单',
        // 票据管理
        'ticketManagePush': '票据入库',
        'ticketManageGet': '票据领取',
        // 运营管理
        'driverAudit': '司机审核',
        'vehicleAudit': '车主审核',
        'feedback': '意见反馈',
        'station': '站点管理',
        // 业务设置
        'platform': '平台管理',
        'driverPort': '司机管理',
        'passengerPort': '乘客管理',
        'ticketing': '票务配置',
        'seat': '座位排版',
        'protocol': '协议管理',
        'chartered': '包车业务',
        'regionalRestrictions': '区域限制',
        'sensitivePersonnel': '敏感人员',
        'Notification': '司机端通知',
        'training': '培训计划',
        'securityTemplate': '安检模板',
        'orderStationSettle': '站点结算',
        'stationReferrerConfig': '推荐配置',
        // 规则管理
        'hitchRidePricingRule': '计价规则',
        'hitchRideCancelRule': '销单规则',
        'hitchRideSettleRule': '抽成规则',
        'hitchRideWithdrawalRule': '提现规则',
        'hitchRideDriverAuditRule': '车主认证',
        'czHitchRideSettleRule': '场站抽成',
        'driverWithdrawalRule': '司机提现',
        'dispatchWithdrawalRule': '业务提现',
        'hitchRideAutoAccept': '抢单配置',
        // 业务管理
        'commission': '提成规则',
        'riskConfig': '风控管理',
        // 活动管理
        'invitation': '司机拉新',
        'chargeOrder': '首单奖励',
        // 营销管理
        'top': '顶部广告',
        'topic': '专题广告',
        'carousel': '轮播广告',
        'sticker': '贴纸广告',
        'coupon': '优惠券',
        'couponReceiving': '领券记录',
        'recommendedLine': '推荐线路',
        'marketingActivity': '活动管理',
        // 数据分析
        'dataOverview': '数据概览',
        'vehicleAnalysis': '车辆分析',
        'driverAnalysis': '司机分析',
        'orderAnalysis': '订单分析',
        'revenueAnalysis': '营收分析',
        // 统计分析
        'hitchRideOrderStatistics': '平台数据',
        'operationData': '运营数据',
        'vehicleFlowing': '车辆数据',
        'driverFlowing': '司机数据',
        // AI管理
        'aiCard': '智能服务',
        'aiConfig': '识别配置',
        // 短信管理
        'smsTemplate': '短信模板',
        'smsRecord': '短信记录',
        'smsConfig': '短信配置',
        'smsStatistics': '短信统计',
        // 系统设置
        'member': '后台账号',
        'role': '角色管理',
        'dataBackup': '数据备份',
        'organization': '机构名称',
        'log': '操作日志',
        'inspector': '安检员账号',
        'hitchRideAdverseRecord': '背景审核',
        // 场站管理
        'czLine': '线路管理',
        'airportStart': '发车场站',
        'czAccount': '员工账号',
        // 文旅管理
        'travelLine': '文旅线路',
        'travelGoods': '商品管理',
        'travelReservation': '行程预约',
        'travelReservationManager': '预约管理',
        'travelOrder': '订单管理',
        'travelItinerary': '行程管理',
        // 渠道管理
        'channelAudit': '渠道审核',
        'channelList': '渠道列表',
        'channelOrder': '渠道订单',
        'channelFinancial': '渠道财务',
        'channelCommission': '佣金配置',
        'channelWithdrawal': '提现管理',
        // 旅游包车
        'charteredOrder': '包车订单',
        'charteredWork': '包车工单',
        'charteredFinancial': '包车财务',
        'charteredSetting': '包车设置',
        'charteredStatistics': '数据统计',
        // 代客下单
        'orderForm': '平台下单',
        'orderFormByChannel2': '窗口售票',
        'orderFormByChannel3': '窗口售票',
        'orderFormHitchRide': '顺风车代客下单',
        // 个人中心
        'myProfile': '个人中心'
      };
      return titleMap[routeName] || '';
    },
    // 根据路径查找菜单项
    findMenuByPath(path) {
      for (const menu of this.menuCache) {
        // 检查一级菜单
        if (menu.path === path) {
          return menu;
        }
        // 检查二级菜单
        if (menu.children && menu.children.length > 0) {
          for (const child of menu.children) {
            if (child.path === path) {
              return { ...child, parent: menu };
            }
          }
        }
      }
      return null;
    },
    // 加载菜单缓存
    async loadMenuCache() {
      try {
        const url = "/api/v1/manage/menu/permission";
        const data = await this.$axios.get(url);
        if (data && data.code === 1) {
          this.menuCache = data.data.menu || [];
        }
      } catch (e) {
        console.error('加载菜单失败', e);
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    details() {
      let permissions = this.$store.getters.permissionsGetter.split(",").map((value) => Number(value));

      if (permissions.includes(42)) {
        this.billVisible = false;
        this.$router.push("/costCenter");
      } else {
        this.$message.info("无权限查看，请通知平台管理员操作");
      }
    },
    async getCityList() {
      const url = "/api/v1/manage/hitchRide/city";
      const { code, data } = await this.$axios.get(url);
      if (code === 1) {
        let cityList = data.map((item) => {
          return {
            ...item,
            label: item.cityName,
            value: item.gaodeCityCode,
          };
        });
        this.$store.commit("muCityList", cityList);
      }
    },
  },
  destroyed() {
    // 取消mqtt订阅
    this.$bus.$off('menu-updated', this.loadMenuCache)
  },
};
</script>

<style lang="less">
#frame {
  height: 100%;

  .frame-content {
    width: 100%;
    height: calc(100% - 48px);
    display: flex;
    align-items: stretch;
    overflow: hidden;

    #frame-menu {
      flex-shrink: 0;
      box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);
      z-index: 10;
    }

    .frame-inner-box {
      flex: 1;
      margin: 16px;
      height: calc(100% - 32px);
      min-width: 0;
      overflow: hidden;
      display: flex;
      flex-direction: column;

      // 全屏布局时移除外边距
      &.fullscreen-box {
        margin: 0;
        height: 100%;
      }

      // 页面头部栏
      .page-header-bar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 12px 20px;
        background: #fff;
        border-radius: 8px;
        margin-bottom: 12px;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
        flex-shrink: 0;

        .page-header-left {
          display: flex;
          align-items: center;
          gap: 16px;

          .page-title {
            display: flex;
            align-items: center;
            gap: 8px;
            font-size: 16px;
            font-weight: 600;
            color: #303133;

            i {
              font-size: 18px;
              color: #2B77FF;
            }
          }

          .page-breadcrumb {
            padding-left: 16px;
            border-left: 1px solid #dcdfe6;

            .el-breadcrumb__item {
              .el-breadcrumb__inner {
                font-size: 13px;
                color: #909399;

                &.is-link {
                  color: #606266;
                  font-weight: normal;

                  &:hover {
                    color: #2B77FF;
                  }
                }
              }

              &:last-child {
                .el-breadcrumb__inner {
                  color: #303133;
                  font-weight: 500;
                }
              }
            }
          }
        }

        .page-header-right {
          display: flex;
          align-items: center;
          gap: 12px;
        }
      }

      .breadcrumb-box {
        margin-bottom: 16px;
      }

      .frame-inner {
        width: 100%;
        flex: 1;
        min-height: 0;
        padding: 20px;
        box-sizing: border-box;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
        position: relative;
        overflow: auto;

        &>div {
          box-sizing: border-box;
          height: 100%;
        }

        // 数据分析模块使用全屏布局（无内边距、无背景）
        &.fullscreen-layout {
          padding: 0;
          background-color: transparent;
          box-shadow: none;
          border-radius: 0;
        }
      }

      .breadcrumb-box+.frame-inner {
        height: calc(100% - 48px);
      }
    }

    .frame-inner-box-fixed {
      flex: 1;
      box-sizing: border-box;
      min-width: 0;
      height: 100%;
      margin: 0;
      padding: 16px;
      overflow: hidden;

      .breadcrumb-box {
        margin-bottom: 16px;
      }

      .frame-inner {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        position: relative;
        overflow: auto;

        &>div {
          box-sizing: border-box;
          height: 100%;
        }
      }

      .breadcrumb-box+.frame-inner {
        height: calc(100% - 48px);
      }
    }




  }
}

// 欠费提示
.rich {
  .content {
    margin-bottom: 20px;

    span {
      color: red;
    }
  }

  .el-dialog__body {
    padding-top: 40px !important;
  }

  .el-dialog__footer {
    text-align: center;
    padding-bottom: 50px !important;
  }
}
</style>
